import React from 'react';
import PropTypes from 'prop-types';
import './radio-group.scss';

/**
 * Tired of making radio button groups by hand? This is the component for you.
 * Simply pass this component a data prop of an array of objects, where each object has
 * a label and value property.
 *
 * The activeValue prop should match the currently selected value, and is what will be used
 * to set which radio will be shown as active.
 *
 * For accessibility, please provide the radio group with a 'name' prop that is unique among
 * the other radio groups on the page.
 *
 * @example
 * <RadioGroup
 *   label='Some example radios:'
 * * name='some-example-radios'
 *   data={[
 *     {
 *       label: <span>This could be a React.Node or a string!</span>,
 *       value: 20
 *     }, {
 *       label: 'This could be a React.Node or a string!',
 *       value: 40
 *     }
 *   ]}
 *   activeValue={20}
 *   onChange={(e) => this.updateValue(e.target.value)}
 * />
 */

export default class RadioGroup extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.node,
        value: PropTypes.string
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    activeValue: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.node
  };

  static defaultProps = {
    onChange: () => {}
  };

  makeRadioItem = (item, i) => {
    const value = item.value;
    return (
      <label key={i} className='radio-group__item'>
        <input
          type='radio'
          className='radio-group__input'
          name={this.props.name}
          value={value}
          checked={value === this.props.activeValue}
          onChange={this.props.onChange}
        />
        <span role='radio' className='fancy-radio' />
        <span className='radio-group__label-wrapper'>{item.label}</span>
      </label>
    );
  };

  render() {
    const label = this.props.label ? (
      <div className='radio-group__label'>{this.props.label}</div>
    ) : null;
    return (
      <div className='radio-group'>
        {label}
        {this.props.data.map(this.makeRadioItem)}
      </div>
    );
  }
}
